module.exports = __webpack_public_path__ + "img/4.a6f9f4c2.svg";